import {
    createStore,
    compose,
    applyMiddleware,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer, AppState } from '@root/app/react/reducer';
import rootSaga from '@app/react/saga';
import { dialogMiddleware } from '@app/react/middleware';
import { toJsonDefaultUnit } from '@app/react/common/toJsonDefaultUnit';

const rootPersistConfig = {
    key: 'root',
    storage,
    whitelist: ['yourDesign'],
};

type ConfigureStoreRT = {
    store: ReturnType<typeof createStore>,
    persistor: ReturnType<typeof persistStore>,
};

export const configureStore = (initialProps: AppState): ConfigureStoreRT => {
    // use devtools if we are in a browser and the extension is enabled
    const composeEnhancers = (typeof window !== 'undefined'
            && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
        || compose;

    // サーバから直接届くものは camelCase ではない
    initialProps.defaultUnit = toJsonDefaultUnit(initialProps.defaultUnit);

    const prootReducer = persistReducer(rootPersistConfig, rootReducer);

    const sagaMiddleware = createSagaMiddleware();
    const store = createStore(
        prootReducer,
        initialProps,
        composeEnhancers(applyMiddleware(dialogMiddleware, sagaMiddleware)),
    );
    const persistor = persistStore(store);
    sagaMiddleware.run(rootSaga);

    return { store, persistor };
};
